import { render, staticRenderFns } from "./Delivery.vue?vue&type=template&id=280acb4f&scoped=true&v-if=this.pickupAndDelivery.accessorials.length%20%3E%200"
import script from "./Delivery.vue?vue&type=script&lang=js"
export * from "./Delivery.vue?vue&type=script&lang=js"
import style0 from "./Delivery.vue?vue&type=style&index=0&id=280acb4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280acb4f",
  null
  
)

export default component.exports